import React from "react";
import Synonyms from "./Synonyms";

export default function Meaning(props) {
  return (
    <div className="Meaning">
      <h3 className="text-capitalize">{props.meaning.partOfSpeech}</h3>
      {props.meaning.definitions.map(function (definition, index) {
        return (
          <span key={index}>
            <p>
              <strong>{definition.definition}</strong>
              <br />
              <em> {definition.example}</em>
            </p>
          </span>
        );
      })}
      <Synonyms synonyms={props.meaning.synonyms} />
    </div>
  );
}
